import React from "react";
import { Form } from "antd";
import { IOrganisation } from "../../../organisations/model/Organisation";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
import OrganisationForm from "./OrganisationForm";
import DataGridConfigurationBuilder from "../../../core/ui/components/grid/DataGridConfigurationBuilder";
import TickBox from "../../../core/ui/components/grid/TickBox";
import { IRegistryInstitution } from "../../model/RegistryInstitution";

interface OrganisationGridProps {
  translate: any;
  organisations: IOrganisation[];
  createOrganisation: any;
  referenceLoader?: boolean;
  institutions: IRegistryInstitution[];
  updateOrganisation: any;
  showDetails;
}
const OrganisationGrid: React.FC<OrganisationGridProps> = ({
  translate,
  organisations,
  createOrganisation,
  referenceLoader,
  institutions,
  showDetails,
  updateOrganisation
}) => {
  const builder = DataGridConfigurationBuilder({
    translate,
    resourcePrefix: "editors.organisations"
  });
  const columns = builder.buildColumns(
    "name",
    "institutionName",
    {
      name: "valid",
      dataKey: "valid",
      sortable: false,
      align: "center",
      render: (record) => <TickBox value={record.valid} />
    },
    {
      name: "details",
      dataKey: "details",
      sortable: false,
      align: "center",
      render: (record) => (
        <button
          type="button"
          className="ant-btn ant-btn-link ant-btn-sm"
          onClick={() => showDetails(record.id)}
        >
          <span>{translate("editors.organisations.details.button_text")}</span>
        </button>
      )
    }
  );

  const [CreateForm] = Form.useForm();
  const [UpdateForm] = Form.useForm();
  return (
    <DataGrid
      title={translate("editors.organisations.title")}
      columns={columns}
      translate={translate}
      dataSource={organisations || []}
      allowCreate={true}
      allowUpdate={true}
      addButtonText={translate("editors.organisations.add_new_text")}
      createForm={
        <OrganisationForm
          translate={translate}
          form={CreateForm}
          institutions={institutions}
        />
      }
      updateForm={
        <OrganisationForm
          translate={translate}
          form={UpdateForm}
          institutions={institutions}
        />
      }
      createModalTitle={`${translate(
        "editors.organisations.create_modal_title"
      )}`}
      loading={referenceLoader}
      onCreate={(e) => {
        createOrganisation(e);
      }}
      onUpdate={(e) => {
        updateOrganisation(e);
      }}
      booleanColumnKeys={["valid"]}
      createModalClass={"modal-width"}
      updateModalClass={"modal-width"}
      keyProperty={"id"}
      CreateFormInstance={CreateForm}
      UpdateFormInstance={UpdateForm}
      createActionPosition={"topRight"}
    />
  );
};
export default OrganisationGrid;
